module.exports = __webpack_public_path__ + "assets/img/cart-null-back.e99c57f3.png";